"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePolicyHolderSchema = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
const PolicyHolderResidenceStatus_1 = require("../enums/PolicyHolderResidenceStatus");
const Address_1 = require("./Address");
const Name_1 = require("./Name");
const Email_1 = require("./Email");
exports.impossiblePolicyHolderSchema = zod_1.z.object({
    name: zod_1.z.nullable(Name_1.impossibleNameSchema).optional(),
    email: zod_1.z.nullable(Email_1.impossibleEmailSchema).optional(),
    address: zod_1.z.nullable(Address_1.impossibleAddressSchema).optional(),
    addressRaw: zod_1.z.nullable(zod_1.z.string().min(constants_1.MIN_DEFAULT_STRING_LENGTH).max(128).regex(constants_1.REGEX.defaultString)).optional(),
    phoneNumber: zod_1.z.nullable(zod_1.z.string().regex(constants_1.REGEX.phoneNumber)).optional(),
    isHomeOwner: zod_1.z.nullable(zod_1.z.boolean()).optional(),
    isMilitary: zod_1.z.nullable(zod_1.z.boolean()).optional(),
    residenceStatus: zod_1.z.nullable(zod_1.z.nativeEnum(PolicyHolderResidenceStatus_1.PolicyHolderResidenceStatus)).optional(),
    tenureInYears: zod_1.z.nullable(zod_1.z.number().min(0).max(110)).optional(),
}).strict();
